const prefix = 'NOTES';

export const GET_NOTES = Symbol(`${prefix}/GET_NOTES`);
export const GET_NOTES_SUCCESS = Symbol(`${prefix}/GET_NOTES_SUCCESS`);
export const GET_NOTES_FAIL = Symbol(`${prefix}/GET_NOTES_FAIL`);

export const SEARCH_NOTES = Symbol(`${prefix}/SEARCH_NOTES`);
export const SEARCH_NOTES_SUCCESS = Symbol(`${prefix}/SEARCH_NOTES_SUCCESS`);
export const SEARCH_NOTES_FAIL = Symbol(`${prefix}/SEARCH_NOTES_FAIL`);

export const GET_SINGLE_NOTE = Symbol(`${prefix}/GET_SINGLE_NOTE`);
export const GET_SINGLE_NOTE_SUCCESS = Symbol(`${prefix}/GET_SINGLE_NOTE_SUCCESS`);
export const GET_SINGLE_NOTE_FAIL = Symbol(`${prefix}/GET_SINGLE_NOTE_FAIL`);

export const UPDATE_INDEX_PREFERENCES = Symbol(`${prefix}/UPDATE_INDEX_PREFERENCES`);
export const UPDATE_INDEX_PREFERENCES_SUCCESS = Symbol(`${prefix}/UPDATE_INDEX_PREFERENCES_SUCCESS`);
export const UPDATE_INDEX_PREFERENCES_FAIL = Symbol(`${prefix}/UPDATE_INDEX_PREFERENCES_FAIL`);

export const UPDATE_NOTE = Symbol(`${prefix}/UPDATE_NOTE`);
export const UPDATE_NOTE_SUCCESS = Symbol(`${prefix}/UPDATE_NOTE_SUCCESS`);
export const UPDATE_NOTE_FAIL = Symbol(`${prefix}/UPDATE_NOTE_FAIL`);

export const DELETE_NOTE = Symbol(`${prefix}/DELETE_NOTE`);
export const DELETE_NOTE_SUCCESS = Symbol(`${prefix}/DELETE_NOTE_SUCCESS`);
export const DELETE_NOTE_FAIL = Symbol(`${prefix}/DELETE_NOTE_FAIL`);

export const UPDATE_URL = Symbol(`${prefix}/UPDATE_URL`);
export const UPDATE_URL_SUCCESS = Symbol(`${prefix}/UPDATE_URL_SUCCESS`);
export const UPDATE_URL_FAIL = Symbol(`${prefix}/UPDATE_URL_FAIL`);

export const SAVE_TEMPLATE = Symbol(`${prefix}/SAVE_TEMPLATE`);
export const SAVE_TEMPLATE_SUCCESS = Symbol(`${prefix}/SAVE_TEMPLATE_SUCCESS`);
export const SAVE_TEMPLATE_FAIL = Symbol(`${prefix}/SAVE_TEMPLATE_FAIL`);

export const GET_TEMPLATES = Symbol(`${prefix}/GET_TEMPLATES`);
export const GET_TEMPLATES_SUCCESS = Symbol(`${prefix}/GET_TEMPLATES_SUCCESS`);
export const GET_TEMPLATES_FAIL = Symbol(`${prefix}/GET_TEMPLATES_FAIL`);

export const REORDER_NOTE_TEMPLATES = Symbol(`${prefix}/REORDER_NOTE_TEMPLATES`);
export const REORDER_NOTE_TEMPLATES_SUCCESS = Symbol(`${prefix}/REORDER_NOTE_TEMPLATES_SUCCESS`);
export const REORDER_NOTE_TEMPLATES_FAIL = Symbol(`${prefix}/REORDER_NOTE_TEMPLATES_FAIL`);

export const RENAME_NOTE = Symbol(`${prefix}/RENAME_NOTE`);
export const RENAME_NOTE_SUCCESS = Symbol(`${prefix}/RENAME_NOTE_SUCCESS`);
export const RENAME_NOTE_FAIL = Symbol(`${prefix}/RENAME_NOTE_FAIL`);

export const RESTRICTIONS_NOTE = Symbol(`${prefix}/RESTRICTIONS_NOTE`);
export const RESTRICTIONS_NOTE_SUCCESS = Symbol(`${prefix}/RESTRICTIONS_NOTE_SUCCESS`);
export const RESTRICTIONS_NOTE_FAIL = Symbol(`${prefix}/RESTRICTIONS_NOTE_FAIL`);

export const REORDER_NOTES = Symbol(`${prefix}/REORDER_NOTES`);
export const REORDER_NOTES_SUCCESS = Symbol(`${prefix}/REORDER_NOTES_SUCCESS`);
export const REORDER_NOTES_FAIL = Symbol(`${prefix}/REORDER_NOTES_FAIL`);

export const CREATE_NOTE = Symbol(`${prefix}/CREATE_NOTE`);
export const CREATE_NOTE_FROM_TEMPLATE = Symbol(`${prefix}/CREATE_NOTE_FROM_TEMPLATE`);
export const CREATE_NOTE_SUCCESS = Symbol(`${prefix}/CREATE_NOTE_SUCCESS`);
export const CREATE_NOTE_FAIL = Symbol(`${prefix}/CREATE_NOTE_FAIL`);

export const DUPLICATE_NOTE = Symbol(`${prefix}/DUPLICATE_NOTE`);
export const DUPLICATE_NOTE_SUCCESS = Symbol(`${prefix}/DUPLICATE_NOTE_SUCCESS`);
export const DUPLICATE_NOTE_FAIL = Symbol(`${prefix}/DUPLICATE_NOTE_FAIL`);

export const GET_NOTE_GROUPS = Symbol(`${prefix}/GET_NOTE_GROUPS`);
export const GET_NOTE_GROUPS_SUCCESS = Symbol(`${prefix}/GET_NOTE_GROUPS_SUCCESS`);
export const GET_NOTE_GROUPS_FAIL = Symbol(`${prefix}/GET_NOTE_GROUPS_FAIL`);

export const CREATE_NOTE_GROUP = Symbol(`${prefix}/CREATE_NOTE_GROUP`);
export const CREATE_NOTE_GROUP_SUCCESS = Symbol(`${prefix}/CREATE_NOTE_GROUP_SUCCESS`);
export const CREATE_NOTE_GROUP_FAIL = Symbol(`${prefix}/CREATE_NOTE_GROUP_FAIL`);

export const RENAME_NOTE_GROUP = Symbol(`${prefix}/RENAME_NOTE_GROUP`);
export const RENAME_NOTE_GROUP_SUCCESS = Symbol(`${prefix}/RENAME_NOTE_GROUP_SUCCESS`);
export const RENAME_NOTE_GROUP_FAIL = Symbol(`${prefix}/RENAME_NOTE_GROUP_FAIL`);

export const DELETE_NOTE_GROUP = Symbol(`${prefix}/DELETE_NOTE_GROUP`);
export const DELETE_NOTE_GROUP_SUCCESS = Symbol(`${prefix}/DELETE_NOTE_GROUP_SUCCESS`);
export const DELETE_NOTE_GROUP_FAIL = Symbol(`${prefix}/DELETE_NOTE_GROUP_FAIL`);

export const REORDER_NOTE_GROUP = Symbol(`${prefix}/REORDER_NOTE_GROUP`);
export const REORDER_NOTE_GROUP_SUCCESS = Symbol(`${prefix}/REORDER_NOTE_GROUP_SUCCESS`);
export const REORDER_NOTE_GROUP_FAIL = Symbol(`${prefix}/REORDER_NOTE_GROUP_FAIL`);

export const UPDATE_NOTE_GROUP_VIEW = Symbol(`${prefix}/UPDATE_NOTE_GROUP_VIEW`);
export const UPDATE_NOTE_GROUP_VIEW_SUCCESS = Symbol(`${prefix}/UPDATE_NOTE_GROUP_VIEW_SUCCESS`);
export const UPDATE_NOTE_GROUP_VIEW_FAIL = Symbol(`${prefix}/UPDATE_NOTE_GROUP_VIEW_FAIL`);

export const CREATE_NOTE_COMMENT = Symbol(`${prefix}/CREATE_NOTE_COMMENT`);
export const CREATE_NOTE_COMMENT_SUCCESS = Symbol(`${prefix}/CREATE_NOTE_COMMENT_SUCCESS`);
export const CREATE_NOTE_COMMENT_FAIL = Symbol(`${prefix}/CREATE_NOTE_COMMENT_FAIL`);

export const UPDATE_NOTE_COMMENT = Symbol(`${prefix}/UPDATE_NOTE_COMMENT`);
export const UPDATE_NOTE_COMMENT_SUCCESS = Symbol(`${prefix}/UPDATE_NOTE_COMMENT_SUCCESS`);
export const UPDATE_NOTE_COMMENT_FAIL = Symbol(`${prefix}/UPDATE_NOTE_COMMENT_FAIL`);

export const DELETE_NOTE_COMMENT = Symbol(`${prefix}/DELETE_NOTE_COMMENT`);
export const DELETE_NOTE_COMMENT_SUCCESS = Symbol(`${prefix}/DELETE_NOTE_COMMENT_SUCCESS`);
export const DELETE_NOTE_COMMENT_FAIL = Symbol(`${prefix}/DELETE_NOTE_COMMENT_FAIL`);

export const CREATE_NOTE_TEMPLATE = Symbol(`${prefix}/CREATE_NOTE_TEMPLATE`);
export const CREATE_NOTE_TEMPLATE_SUCCESS = Symbol(`${prefix}/CREATE_NOTE_TEMPLATE_SUCCESS`);
export const CREATE_NOTE_TEMPLATE_FAIL = Symbol(`${prefix}/CREATE_NOTE_TEMPLATE_FAIL`);

export const UPDATE_NOTE_TEMPLATE = Symbol(`${prefix}/UPDATE_NOTE_TEMPLATE`);
export const UPDATE_NOTE_TEMPLATE_SUCCESS = Symbol(`${prefix}/UPDATE_NOTE_TEMPLATE_SUCCESS`);
export const UPDATE_NOTE_TEMPLATE_FAIL = Symbol(`${prefix}/UPDATE_NOTE_TEMPLATE_FAIL`);

export const DELETE_NOTE_TEMPLATE = Symbol(`${prefix}/DELETE_NOTE_TEMPLATE`);
export const DELETE_NOTE_TEMPLATE_SUCCESS = Symbol(`${prefix}/DELETE_NOTE_TEMPLATE_SUCCESS`);
export const DELETE_NOTE_TEMPLATE_FAIL = Symbol(`${prefix}/DELETE_NOTE_TEMPLATE_FAIL`);

export const DUPLICATE_NOTE_TEMPLATE = Symbol(`${prefix}/DUPLICATE_NOTE_TEMPLATE`);
export const DUPLICATE_NOTE_TEMPLATE_SUCCESS = Symbol(`${prefix}/DUPLICATE_NOTE_TEMPLATE_SUCCESS`);
export const DUPLICATE_NOTE_TEMPLATE_FAIL = Symbol(`${prefix}/DUPLICATE_NOTE_TEMPLATE_FAIL`);
